export function useFeatureHandler () {
  const config = useRuntimeConfig().app;
  const value = config.HIDE_CATALOG_FILTERS && config.HIDE_CATALOG_FILTERS.length
    ? config.HIDE_CATALOG_FILTERS
    : 'false';
  const hideVehicleCatalogFilters = value.toLowerCase() === 'true';

  return {
    hideVehicleCatalogFilters,
  };
}
